import { en_to_PIE, setPIEDictionary } from "../transcribe/en_to_PIE.json";
import { fetchJson } from "./fetchJson";

const enToPIEFile = 'en_to_PIE.json';

/** load the PIE dictionary file */
export async function loadPIEDictionary() {
  const entryCount = Object.getOwnPropertyNames(en_to_PIE).length;
  if (entryCount > 0) {
    // data already loaded
    return new Promise((resolve) => resolve('skipped'));
  }

  const p1 = fetchJson(enToPIEFile, loadEvents);
  return Promise.all([p1]);
}

const loadEvents = {
  gotJson(fileName: string, json: any) {
    switch (fileName) {
      case enToPIEFile:
        setPIEDictionary(json as Record<string, string>);
        break;
    }
  },
  gotError(fileName: string, message: string) {
    console.log('error loading data', fileName, message)
  }
}
